import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Categories() {
  return (
    <section className="py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <p className="flex items-center justify-center gap-2 text-sm font-medium text-primary-600">
            <i className="ri-grid-fill"></i> 分类浏览
          </p>
          <h2 className="mt-1 font-display text-2xl text-foreground-900 md:text-3xl">按分类快速找到想看的漫画</h2>
          <p className="mt-2 text-sm text-foreground-600">八大热门分类，精准定位你的口味，追漫不再大海捞针。</p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((c) => (
            <Link
              key={c.name}
              to={`/comics?category=${encodeURIComponent(c.name)}`}
              className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-secondary-300 hover:bg-secondary-50"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-xl text-secondary-700 transition-colors group-hover:bg-secondary-500 group-hover:text-background-50">
                <i className={c.icon}></i>
              </span>
              <div className="min-w-0">
                <h4 className="font-semibold text-foreground-900">{c.name}</h4>
                <p className="mt-0.5 text-xs text-foreground-500">{c.desc}</p>
              </div>
              <i className="ri-arrow-right-s-line ml-auto text-lg text-foreground-300 group-hover:text-secondary-600"></i>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}